import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Funnel.es.js";
const o = e.forwardRef((n, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...n, weights: a }));
o.displayName = "FunnelIcon";
const s = o;
export {
  s as Funnel,
  o as FunnelIcon
};
